import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PerfilId } from '../models/user.model';

export const companyAdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.loadCurrentUser();

  if (user?.id_perfil === PerfilId.CompanyAdmin) {
    return true;
  }

  return router.createUrlTree([user ? authService.getRedirectRoute(user.id_perfil) : '/auth/login']);
};
